var Index = Barba.BaseView.extend({
    namespace: 'index',
    onEnter: function() {
        // The new Container is ready and attached to the DOM.
        $('select').selectric();

        $('.shipping_address').hide()
    },
    onEnterCompleted: function() {
        // The Transition has just finished.


    },
    onLeave: function() {
        // A new Transition toward a new page has just started.
        $('html, body').animate({
            scrollTop: 0
        }, 10);

    },
    onLeaveCompleted: function() {
        // The Container has just been removed from the DOM.
    }
});

// !!!! Don't forget to init the view in page-transitions/barba-init.js !!!!!
